// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__i_KtI","title":"Header_title__2RHUQ","side":"Header_side__wH0Ry"};